import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL ?? ""}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
}
